import { render } from "./Handbook.vue?vue&type=template&id=01a9a6a6"
import script from "./Handbook.vue?vue&type=script&lang=js"
export * from "./Handbook.vue?vue&type=script&lang=js"

import "./Handbook.vue?vue&type=style&index=0&id=01a9a6a6&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__